export default __webpack_public_path__ + "static/bg-accountants-2e96c5252943f9a000cf59cf8bbbaace.png";